// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2806":"c4cddda9fce0a150","2888":"ca07d5290883a1a7","5405":"67e46f67527a9288"}[chunkId] + ".css";
};